import { CMS_HUB_ENTERPRISE, CMS_HUB_PROFESSIONAL, CMS_HUB_STARTER, MARKETING_HUB_ENTERPRISE, MARKETING_HUB_PROFESSIONAL, MARKETING_HUB_STARTER, MARKETING_HUB_FREE, OPERATIONS_HUB_ENTERPRISE, OPERATIONS_HUB_PROFESSIONAL, OPERATIONS_HUB_STARTER, SALES_HUB_ENTERPRISE, SALES_HUB_PROFESSIONAL, SALES_HUB_STARTER, SERVICE_HUB_ENTERPRISE, SERVICE_HUB_PROFESSIONAL, SERVICE_HUB_STARTER, SALES_HUB_FREE, SERVICE_HUB_FREE, CMS_HUB_FREE, OPERATIONS_HUB_FREE } from 'self-service-api/constants/ApiNames';
export const ApiNameToProductTranslationKeyMap = {
  [MARKETING_HUB_FREE]: 'compare.products.FREE.default',
  [MARKETING_HUB_STARTER]: 'compare.products.MARKETING.STARTER',
  [MARKETING_HUB_PROFESSIONAL]: 'compare.products.MARKETING.PROFESSIONAL',
  [MARKETING_HUB_ENTERPRISE]: 'compare.products.MARKETING.ENTERPRISE',
  [SALES_HUB_FREE]: 'compare.products.FREE.default',
  [SALES_HUB_STARTER]: 'compare.products.SALES.STARTER',
  [SALES_HUB_PROFESSIONAL]: 'compare.products.SALES.PROFESSIONAL',
  [SALES_HUB_ENTERPRISE]: 'compare.products.SALES.ENTERPRISE',
  [SERVICE_HUB_FREE]: 'compare.products.FREE.default',
  [SERVICE_HUB_STARTER]: 'compare.products.SERVICE.STARTER',
  [SERVICE_HUB_PROFESSIONAL]: 'compare.products.SERVICE.PROFESSIONAL',
  [SERVICE_HUB_ENTERPRISE]: 'compare.products.SERVICE.ENTERPRISE',
  [CMS_HUB_FREE]: 'compare.products.FREE.default',
  [CMS_HUB_STARTER]: 'compare.products.CMS.STARTER',
  [CMS_HUB_PROFESSIONAL]: 'compare.products.CMS.PROFESSIONAL',
  [CMS_HUB_ENTERPRISE]: 'compare.products.CMS.ENTERPRISE',
  [OPERATIONS_HUB_FREE]: 'compare.products.FREE.default',
  [OPERATIONS_HUB_STARTER]: 'compare.products.OPERATIONS.STARTER',
  [OPERATIONS_HUB_PROFESSIONAL]: 'compare.products.OPERATIONS.PROFESSIONAL',
  [OPERATIONS_HUB_ENTERPRISE]: 'compare.products.OPERATIONS.ENTERPRISE'
};